
angular.module('WcResponsiveTableModule').directive('wcRowSelectHeaderRadio', function() {
        return {
            restrict: 'E',
            template:'',
            scope: {
                wcRowSelectHeaderRadio: '@'
            },
            controller: ['$scope',function($scope){


            }]
        };
    }
);